import { render, staticRenderFns } from "./SuppliersView.vue?vue&type=template&id=ec34de48&scoped=true&lang=pug"
import script from "./SuppliersView.vue?vue&type=script&lang=js"
export * from "./SuppliersView.vue?vue&type=script&lang=js"
import style0 from "./SuppliersView.vue?vue&type=style&index=0&id=ec34de48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec34de48",
  null
  
)

export default component.exports